import React, { useContext } from 'react';
import { CommonTooltipWrapper } from './CommonTooltip.styles';
import getTooltipContext from '../../../context/TooltipContext';

type Props = {
    tooltipId?: string;
    children: any;
    width?: number;
    center?: boolean;
};

const CommonTooltip: React.FC<Props> = (props) => {
    const tooltip = useContext(getTooltipContext());

    const getTooltip = (tooltipId: string | null): string | null => {
        if (!tooltip || tooltip.length === 0 || !tooltipId) return null;
        const strArr = tooltip.replace(/\r\n/g, '\n').split('\n');
        let keepGoing = true;
        let ind = 0;
        let strTooltip: string | null = null;
        if (strArr && strArr.length > 0) {
            while (keepGoing) {
                const str = strArr[ind].split(':');
                if (str && str.length === 2) {
                    if (str[0] === tooltipId) {
                        strTooltip = str[1];
                        keepGoing = false;
                    } else {
                        ind++;
                    }
                } else {
                    ind++;
                }
                if (ind === strArr.length) keepGoing = false;
            }
        }
        return strTooltip;
    };

    return (
        <CommonTooltipWrapper width={props.width}>
            <div className="elem-wrapper">
                {props.children}
                <div className="tooltip-show">{getTooltip(props.tooltipId ?? null)}</div>
            </div>
        </CommonTooltipWrapper>
    );
};

export default CommonTooltip;
